import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlusSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"plus-small, add small"} maskId="square-filled-radius-0-stroke-1-IconPlusSmall"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 6V11.5H18V12.5H12.5V18H11.5V12.5H6V11.5H11.5V6H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPlusSmall;
